import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 6.2c0-2.695 2.097-4.95 4.75-4.95s4.75 2.255 4.75 4.95c0 1.623-.753 2.548-1.349 3.28l-.016.02c-.195.24-.375.462-.543.708-.012.043-.027.11-.042.197-.03.175-.05.39-.05.595v1.75h-5.5V11c0-.205-.02-.422-.05-.595a1.99 1.99 0 0 0-.04-.192 11.35 11.35 0 0 0-.54-.7l-.013-.016C4.007 8.764 3.25 7.84 3.25 6.2Z"
      fill="currentColor"
    />
    <path d="M10 14H6" stroke="currentColor" strokeWidth={1} />
  </svg>
);

const StyledSvgLightbulb = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgLightbulb;
